export function operacaoRadRelatorioPesquisaPreFaturaUnidataInRequest(params = {}) {
  return {
    type: '@operacaoradrelatoriopesquisaprefaturaunidata/OPERACAORADRELATORIOPESQUISAPREFATURAUNIDATA_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoRadRelatorioPesquisaPreFaturaUnidata(fatu_codigo) {
  return {
    type: '@operacaoradrelatoriopesquisaprefaturaunidata/FIND_OPERACAORADRELATORIOPESQUISAPREFATURAUNIDATA',
    payload: { fatu_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoradrelatoriopesquisaprefaturaunidata/FAILED_REQUEST',
  };
}

export function deleteOperacaoRadRelatorioPesquisaPreFaturaUnidata(fatu_codigo, params) {
  return {
    type: '@operacaoradrelatoriopesquisaprefaturaunidata/DELETE_OPERACAORADRELATORIOPESQUISAPREFATURAUNIDATA',
    payload: { fatu_codigo, params },
  };
}

export function updateOperacaoRadRelatorioPesquisaPreFaturaUnidata(operacaoradrelatoriopesquisaprefaturaunidata, params) {
  return {
    type: '@operacaoradrelatoriopesquisaprefaturaunidata/UPDATE_OPERACAORADRELATORIOPESQUISAPREFATURAUNIDATA',
    payload: { operacaoradrelatoriopesquisaprefaturaunidata, params },
  };
}

export function storeOperacaoRadRelatorioPesquisaPreFaturaUnidata(operacaoradrelatoriopesquisaprefaturaunidata, params) {
  return {
    type: '@operacaoradrelatoriopesquisaprefaturaunidata/STORE_OPERACAORADRELATORIOPESQUISAPREFATURAUNIDATA',
    payload: { operacaoradrelatoriopesquisaprefaturaunidata, params },
  };
}

export function successInRequest(
  operacaoradrelatoriopesquisaprefaturaunidata,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoradrelatoriopesquisaprefaturaunidata/SUCCESS_IN_REQUEST',
    payload: { operacaoradrelatoriopesquisaprefaturaunidata, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoradrelatoriopesquisaprefaturaunidata) {
  return {
    type: '@operacaoradrelatoriopesquisaprefaturaunidata/SUCCESS_REQUEST',
    payload: { operacaoradrelatoriopesquisaprefaturaunidata },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoradrelatoriopesquisaprefaturaunidata/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoradrelatoriopesquisaprefaturaunidata/RECORD_FILTERING',
    payload: { params },
  };
}
